import { type TUserorbitApp } from "userorbit-js-core";
import { loadUserorbitToProxy } from "./lib/load-userorbit";

declare global {
  interface Window {
    userorbit: TUserorbitApp | undefined;
  }
}

const userorbitProxyHandler: ProxyHandler<TUserorbitApp> = {
  get(_target, prop, _receiver) {
    return (...args: unknown[]) => loadUserorbitToProxy(prop as string, ...args);
  },
};

const userorbitApp: TUserorbitApp = new Proxy({} as TUserorbitApp, userorbitProxyHandler);

// eslint-disable-next-line import/no-default-export -- Required for UMD
export default userorbitApp;
